import {
    LabTestsEntityOrProceduresEntity,
    MedicationsEntity,
} from '../../../../store/types/prescription';
import { PushStatus } from './FinishedPanel';
import { OneMgSvg } from './OrderMedicineUtils';

export const OrderMedicineNewButton: React.FC<{
    medications: MedicationsEntity[];
    isFetchingCartDetails?: boolean;
    toggleOrderMedicineDialogVisible: (bypassHXNGInfoModal?: boolean) => void;
    isVendorIsOneMg?: boolean;
    cartMxLength: number;
    unavailableMxLength: number;
    pushStatus?: PushStatus;
    bypassHXNGInfoModal?: boolean;
    amount: number;
}> = ({
    medications,
    isFetchingCartDetails,
    toggleOrderMedicineDialogVisible,
    isVendorIsOneMg,
    cartMxLength,
    unavailableMxLength,
    pushStatus,
    bypassHXNGInfoModal,
    amount,
}) => {
    const isCartSuccess = isFetchingCartDetails || cartMxLength > 0;
    if (medications.length === 0) return null;
    return (
        <div
            className={`flex items-start space-x-8 border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 p-8 rounded-8 cursor-pointer ${
                pushStatus !== 'success' ? 'opacity-60 cursor-not-allowed' : ''
            }`}
            onClick={() => toggleOrderMedicineDialogVisible(bypassHXNGInfoModal)}
            style={!isCartSuccess ? { background: '#FBEDEC' } : undefined}
        >
            {!isCartSuccess && (
                <p className="pt-2">
                    <svg
                        className="w-15 h-14 fill-red-primary"
                        viewBox="0 0 15 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7.41699 13.625C5.08105 13.625 2.94824 12.4062 1.78027 10.375C0.612305 8.36914 0.612305 5.90625 1.78027 3.875C2.94824 1.86914 5.08105 0.625 7.41699 0.625C9.72754 0.625 11.8604 1.86914 13.0283 3.875C14.1963 5.90625 14.1963 8.36914 13.0283 10.375C11.8604 12.4062 9.72754 13.625 7.41699 13.625ZM7.41699 3.875C7.06152 3.875 6.80762 4.1543 6.80762 4.48438V7.32812C6.80762 7.68359 7.06152 7.9375 7.41699 7.9375C7.74707 7.9375 8.02637 7.68359 8.02637 7.32812V4.48438C8.02637 4.1543 7.74707 3.875 7.41699 3.875ZM6.60449 9.5625C6.60449 10.0195 6.95996 10.375 7.41699 10.375C7.84863 10.375 8.22949 10.0195 8.22949 9.5625C8.22949 9.13086 7.84863 8.75 7.41699 8.75C6.95996 8.75 6.60449 9.13086 6.60449 9.5625Z" />
                    </svg>
                </p>
            )}
            <div className="space-y-4">
                <p
                    className={`text-13 ${
                        isCartSuccess ? 'text-darwin-accent-bright-blue-800' : ''
                    } font-700`}
                >
                    {isCartSuccess ? 'Order Medicines' : 'Medicines not available'}
                </p>
                {isFetchingCartDetails ? (
                    <div className="min-w-160 h-20 shimmer"></div>
                ) : cartMxLength > 0 ? (
                    <div className="flex items-center space-x-5">
                        {isVendorIsOneMg && (
                            <p>
                                <OneMgSvg width="60" height="24" />
                            </p>
                        )}
                        <p className="text-darwin-neutral_new-800 text-11 font-600">
                            {cartMxLength}/{cartMxLength + unavailableMxLength} available
                        </p>
                        <span className="text-darwin-neutral_new-800 text-16 font-600 relative -top-1">
                            {' '}
                            |{' '}
                        </span>
                        <span className="font-700 text-darwin-neutral_new-800 text-11">
                            ₹{amount}
                        </span>
                    </div>
                ) : (
                    <div className="flex items-center space-x-5">
                        <p className="text-darwin-accent-bright-blue-800 text-13 font-700">
                            Change pin code
                        </p>
                        <p>
                            <svg
                                className="w-18 h-16 fill-darwin-accent-bright-blue-800"
                                viewBox="0 0 17 16"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M1.91699 8.125C1.91699 5.81445 3.13574 3.68164 5.16699 2.51367C7.17285 1.3457 9.63574 1.3457 11.667 2.51367C13.6729 3.68164 14.917 5.81445 14.917 8.125C14.917 10.4609 13.6729 12.5938 11.667 13.7617C9.63574 14.9297 7.17285 14.9297 5.16699 13.7617C3.13574 12.5938 1.91699 10.4609 1.91699 8.125ZM8.03613 11.1973L10.6768 8.55664C10.9053 8.32812 10.9053 7.94727 10.6768 7.69336L8.03613 5.07812C7.78223 4.82422 7.40137 4.82422 7.17285 5.07812C6.91895 5.30664 6.91895 5.6875 7.17285 5.94141L9.38184 8.15039L7.17285 10.3594C6.91895 10.5879 6.91895 10.9688 7.17285 11.1973C7.40137 11.4512 7.78223 11.4512 8.03613 11.1973Z" />
                            </svg>
                        </p>
                    </div>
                )}
            </div>
            {isCartSuccess && (
                <p className="pt-2">
                    <svg
                        className="w-18 h-16 fill-darwin-accent-bright-blue-800"
                        viewBox="0 0 17 16"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M1.91699 8.125C1.91699 5.81445 3.13574 3.68164 5.16699 2.51367C7.17285 1.3457 9.63574 1.3457 11.667 2.51367C13.6729 3.68164 14.917 5.81445 14.917 8.125C14.917 10.4609 13.6729 12.5938 11.667 13.7617C9.63574 14.9297 7.17285 14.9297 5.16699 13.7617C3.13574 12.5938 1.91699 10.4609 1.91699 8.125ZM8.03613 11.1973L10.6768 8.55664C10.9053 8.32812 10.9053 7.94727 10.6768 7.69336L8.03613 5.07812C7.78223 4.82422 7.40137 4.82422 7.17285 5.07812C6.91895 5.30664 6.91895 5.6875 7.17285 5.94141L9.38184 8.15039L7.17285 10.3594C6.91895 10.5879 6.91895 10.9688 7.17285 11.1973C7.40137 11.4512 7.78223 11.4512 8.03613 11.1973Z" />
                    </svg>
                </p>
            )}
        </div>
    );
};

export const BookLabTestNewButton: React.FC<{
    labTests: LabTestsEntityOrProceduresEntity[];
    isFetchingCartDetails?: boolean;
    toggleBookLabTestDialogVisible: (bypassHXNGInfoModal?: boolean) => void;
    cartLxLength: number;
    unavailableLxLength: number;
    totalOptions: number;
    pushStatus?: PushStatus;
    bypassHXNGInfoModal?: boolean;
    amount: number;
}> = ({
    labTests,
    isFetchingCartDetails,
    toggleBookLabTestDialogVisible,
    cartLxLength,
    unavailableLxLength,
    totalOptions,
    pushStatus,
    bypassHXNGInfoModal,
    amount,
}) => {
    const isCartSuccess = isFetchingCartDetails || cartLxLength > 0;
    if (labTests.length === 0) return null;
    return (
        <div
            className={`flex items-start space-x-8 border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 p-8 rounded-8 cursor-pointer ${
                pushStatus !== 'success' ? 'opacity-60 cursor-not-allowed' : ''
            }`}
            onClick={() => toggleBookLabTestDialogVisible(bypassHXNGInfoModal)}
            style={!isCartSuccess ? { background: '#FBEDEC' } : undefined}
        >
            {!isCartSuccess && (
                <p className="pt-2">
                    <svg
                        className="w-15 h-14 fill-red-primary"
                        viewBox="0 0 15 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7.41699 13.625C5.08105 13.625 2.94824 12.4062 1.78027 10.375C0.612305 8.36914 0.612305 5.90625 1.78027 3.875C2.94824 1.86914 5.08105 0.625 7.41699 0.625C9.72754 0.625 11.8604 1.86914 13.0283 3.875C14.1963 5.90625 14.1963 8.36914 13.0283 10.375C11.8604 12.4062 9.72754 13.625 7.41699 13.625ZM7.41699 3.875C7.06152 3.875 6.80762 4.1543 6.80762 4.48438V7.32812C6.80762 7.68359 7.06152 7.9375 7.41699 7.9375C7.74707 7.9375 8.02637 7.68359 8.02637 7.32812V4.48438C8.02637 4.1543 7.74707 3.875 7.41699 3.875ZM6.60449 9.5625C6.60449 10.0195 6.95996 10.375 7.41699 10.375C7.84863 10.375 8.22949 10.0195 8.22949 9.5625C8.22949 9.13086 7.84863 8.75 7.41699 8.75C6.95996 8.75 6.60449 9.13086 6.60449 9.5625Z" />
                    </svg>
                </p>
            )}
            <div className="space-y-4">
                <p
                    className={`text-13 ${
                        isCartSuccess ? 'text-darwin-accent-bright-blue-800' : ''
                    } font-700`}
                >
                    {isCartSuccess ? 'Book Lab Tests' : 'Lab Tests not available'}
                </p>
                {isFetchingCartDetails ? (
                    <div className="min-w-160 h-20 shimmer"></div>
                ) : cartLxLength > 0 ? (
                    <div className="flex items-center space-x-5">
                        <p className="text-darwin-neutral_new-800 text-11 font-600">
                            {cartLxLength}/{cartLxLength + unavailableLxLength} available
                        </p>
                        <p>
                            <img
                                src={'/images/labs_vendors.gif'}
                                alt={'labs_vendors'}
                                className="h-24 min-w-60"
                            />
                        </p>
                        {totalOptions > 1 && (
                            <p className="text-darwin-neutral_new-800 text-11 font-600">
                                +{totalOptions - 1}
                            </p>
                        )}
                        <span className="text-darwin-neutral_new-800 text-16 font-600 relative -top-1">
                            {' '}
                            |{' '}
                        </span>
                        <span className="font-700 text-darwin-neutral_new-800 text-11">
                            ₹{amount}
                        </span>
                    </div>
                ) : (
                    <div className="flex items-center space-x-5">
                        <p className="text-darwin-accent-bright-blue-800 text-12 font-700">
                            Change pin code
                        </p>
                        <p>
                            <svg
                                className="w-18 h-16 fill-darwin-accent-bright-blue-800"
                                viewBox="0 0 17 16"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M1.91699 8.125C1.91699 5.81445 3.13574 3.68164 5.16699 2.51367C7.17285 1.3457 9.63574 1.3457 11.667 2.51367C13.6729 3.68164 14.917 5.81445 14.917 8.125C14.917 10.4609 13.6729 12.5938 11.667 13.7617C9.63574 14.9297 7.17285 14.9297 5.16699 13.7617C3.13574 12.5938 1.91699 10.4609 1.91699 8.125ZM8.03613 11.1973L10.6768 8.55664C10.9053 8.32812 10.9053 7.94727 10.6768 7.69336L8.03613 5.07812C7.78223 4.82422 7.40137 4.82422 7.17285 5.07812C6.91895 5.30664 6.91895 5.6875 7.17285 5.94141L9.38184 8.15039L7.17285 10.3594C6.91895 10.5879 6.91895 10.9688 7.17285 11.1973C7.40137 11.4512 7.78223 11.4512 8.03613 11.1973Z" />
                            </svg>
                        </p>
                    </div>
                )}
            </div>
            {isCartSuccess && (
                <p className="pt-2">
                    <svg
                        className="w-18 h-16 fill-darwin-accent-bright-blue-800"
                        viewBox="0 0 17 16"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M1.91699 8.125C1.91699 5.81445 3.13574 3.68164 5.16699 2.51367C7.17285 1.3457 9.63574 1.3457 11.667 2.51367C13.6729 3.68164 14.917 5.81445 14.917 8.125C14.917 10.4609 13.6729 12.5938 11.667 13.7617C9.63574 14.9297 7.17285 14.9297 5.16699 13.7617C3.13574 12.5938 1.91699 10.4609 1.91699 8.125ZM8.03613 11.1973L10.6768 8.55664C10.9053 8.32812 10.9053 7.94727 10.6768 7.69336L8.03613 5.07812C7.78223 4.82422 7.40137 4.82422 7.17285 5.07812C6.91895 5.30664 6.91895 5.6875 7.17285 5.94141L9.38184 8.15039L7.17285 10.3594C6.91895 10.5879 6.91895 10.9688 7.17285 11.1973C7.40137 11.4512 7.78223 11.4512 8.03613 11.1973Z" />
                    </svg>
                </p>
            )}
        </div>
    );
};
